/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["M\xE1nudagur", "\xDEri\xF0judagur", "Mi\xF0vikudagur", "Fimmtudagur", "F\xF6studagur", "Laugardagur", "Sunnudagur"], e = ["Jan\xFAar", "Febr\xFAar", "Mars", "Apr\xEDl", "Ma\xED", "J\xFAn\xED", "J\xFAl\xED", "\xC1g\xFAst", "September", "Okt\xF3ber", "N\xF3vember", "Desember"], r = "\xC1r", n = "\xC1r", t = "M\xE1nu\xF0ur", u = "Vika", d = "Dagur", s = "\xCD dag", g = "Enginn atbur\xF0ur", l = "Allan daginn", i = "Ey\xF0a", M = "B\xFA\xF0u til vi\xF0bur\xF0", y = "dddd D MMMM YYYY", m = { weekDays: a, months: e, years: "\xC1r", year: "\xC1r", month: "M\xE1nu\xF0ur", week: "Vika", day: "Dagur", today: "\xCD dag", noEvent: "Enginn atbur\xF0ur", allDay: "Allan daginn", deleteEvent: "Ey\xF0a", createEvent: "B\xFA\xF0u til vi\xF0bur\xF0", dateFormat: "dddd D MMMM YYYY" };
export {
  l as allDay,
  M as createEvent,
  y as dateFormat,
  d as day,
  m as default,
  i as deleteEvent,
  t as month,
  e as months,
  g as noEvent,
  s as today,
  u as week,
  a as weekDays,
  n as year,
  r as years
};
